const MINUTE = 60 * 1000;

export function nowOffset({ renderedOffset, renderedAt, now, windowLength }) {
  const offset = renderedOffset + Math.floor((now - renderedAt) / MINUTE);
  return offset >= 0 && offset <= windowLength ? offset : null;
}
